import {
  type CreateToastFnReturn,
  useToast as useChakraToast,
} from '@chakra-ui/react';
import { useMemo } from 'react';

import { useChartTheme } from '@revelio/replots';
import {
  type ToastApi,
  type ToastOptions,
  useToast as useRevelioToast,
} from '@revelio/ui';

function adaptChakraToast(chakra: CreateToastFnReturn): ToastApi {
  const api = ((options: ToastOptions) => chakra(options) ?? '') as ToastApi;
  api.isActive = (id) => chakra.isActive(id);
  api.close = (id) => chakra.close(id);
  api.closeAll = () => chakra.closeAll();
  api.update = (id, options) => chakra.update(id, options);
  api.promise = (promise, options) => {
    chakra.promise(promise, options);
    return promise;
  };
  return api;
}

export function useToast(): ToastApi {
  const { isNewTheme } = useChartTheme();
  const chakraToast = useChakraToast();
  const revelioToast = useRevelioToast();
  // Memoized so the returned api is referentially stable like the hooks it
  // wraps — consumers key effects and cleanups on it.
  const legacyToast = useMemo(
    () => adaptChakraToast(chakraToast),
    [chakraToast]
  );
  return isNewTheme ? revelioToast : legacyToast;
}
